
import { Button, Col, Form, Input, notification, Popconfirm, Row, Spin, Switch, Table } from "antd";
import { EditOutlined, DeleteOutlined, PlusOutlined } from '@ant-design/icons';
import { useEffect, useState } from "react";
import { API_ERR_MESSAGE, CHARACTER_PATTERN, CHARACTER_PATTERN_MESSAGE } from "../../../../../config/constant";
import { addCountryApi, listOfCountryApi, updateCountryApi } from "../../../../../config/Api";
export const Country = () => {

    const [dataSource, setDataSource] = useState([]);
    const [displayData, setDisplayData] = useState([]);
    const [buttonName, setButtonName] = useState('ADD')
    const [countryData, setCountryData] = useState()
    const [editCountryRecord, setEditCountryRecord] = useState()
    const [loading, setLoading] = useState(false)

    const [form] = Form.useForm();

    // get the list of all Countries
    const getListOfCountries = () => {
        setLoading(true)

        listOfCountryApi()
            .then((res) => {
                if (res.status === 200) {
                    setDataSource(res.data.data);
                    setDisplayData(res.data.data);
                }
                setLoading(false)
            })
            .catch((err) => {
                notification.error({
                    message: 'something went wrong',
                });
            });
    }

    // call when user click on edit
    const editCountry = (data) => {
        setButtonName("UPDATE")
        form.setFieldsValue({ 'name': data.name })
        setEditCountryRecord(data);
    }

    useEffect(() => {
        getListOfCountries()
    }, []);

    // filter data according to user search input 
    useEffect(() => {
        filterCountry(countryData);
    }, [countryData]);

    // filter country list
    const filterCountry = (data) => {
        if (!data) {
            setDisplayData(dataSource);
        } else {
            let tmp = [];
            dataSource.length > 0 && dataSource.forEach((element) => {
                if (element?.name.toUpperCase().indexOf(data.toUpperCase()) !== -1) {
                    tmp.push(element);
                }
            });
            setDisplayData(tmp);
        }
    };



    const onFinish = (values) => {

        if (buttonName == 'ADD') {
            const data = {
                "name": values.name,
                "status": true
            }
            addCountryApi(data)
                .then((res) => {
                    if (res.status == 200) {
                        form.setFieldsValue({ 'name': '' })
                        notification.success({
                            message: "Country added successfully",
                        });
                        getListOfCountries()
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
        else {
            const data = {
                "name": values.name,
                "status": values.status
            }
            updateCountryApi(editCountryRecord.id, data)
                .then((res) => {
                    if (res.status == 200) {
                        setButtonName("ADD")
                        notification.success({
                            message: "Country Update successfully",
                        });
                        getListOfCountries()
                        form.setFieldsValue({ 'name': '' })
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
    };

    const columns = [
        {
            title: 'Name',
            dataIndex: 'name',
            key: 'name',
            render: (text) => <a>{text}</a>,
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                <div className="action align-self-center">
                    <Button icon={<EditOutlined />} onClick={(e) => { setButtonName('UPDATE'); editCountry(record) }} className="me-2" />
                    <Popconfirm title="Sure to delete?" >
                        <Button icon={<DeleteOutlined />} />
                    </Popconfirm>
                </div>
            ),
        },
    ];

    const resetData = () => {
        form.resetFields()
    };
    return (
        <div className="Diseases">
            <Row>
                <Col xl={14}>
                    <Form
                        name="addDiseasesForm"
                        // className="addDiseasesForm"
                        form={form}
                        onFinish={onFinish}
                    >
                        <Row className="addDiseasesForm">
                            <Col xl={8}>
                                <Form.Item
                                    name="name"
                                    rules={[
                                        {
                                            required: true,
                                            message: "Please Enter Country Name!",
                                        },
                                        {
                                            pattern: CHARACTER_PATTERN,
                                            message: CHARACTER_PATTERN_MESSAGE,
                                        }
                                    ]}
                                >
                                    <Input placeholder="Enter Country Name" className="p-2" />
                                </Form.Item>
                            </Col>
                            <Col xl={8}>
                                <Button htmlType="submit" className="submit-button  border-0 rounded ms-2" icon={buttonName == 'ADD' ? <PlusOutlined style={{ fontSize: "1.2rem" }} /> : <EditOutlined style={{ fontSize: "1rem" }} />}
                                >
                                    {buttonName}
                                </Button>
                            </Col>
                        </Row>

                    </Form>

                </Col>
                <Col xl={4} className="text-end align-self-center">
                    <h6>Total : {displayData.length > 0 ? displayData.length : 0}  </h6>
                </Col>
                <Col xl={6} className="align-self-center">
                    <Input.Search placeholder="Search Country Name"
                        onChange={(e) => { filterCountry(e.target.value); setCountryData(e.target.value) }}
                        className="p-2" />
                </Col>
            </Row>
            <Spin spinning={loading} className="spinner-code">
                <Row>
                    <Table
                        columns={columns}
                        rowKey="id"
                        dataSource={displayData}
                        // pagination={false}
                        scroll={{ x: "max-content" }}
                        className="w-100"
                    />
                </Row>
            </Spin>
        </div>
    )
}
